import type {Context, ReactNode} from 'react'
import {createContext, memo, useContext} from 'react'

import type {BuildTypeId} from '../../../../types'

export const BuildTypesContext: Context<
  (buildTypeId: BuildTypeId, archivedProject: boolean, isFavorite: boolean) => ReactNode
> = createContext((_, __, ___): ReactNode => null)
type NestedBuildTypesProps = {
  buildTypeId: BuildTypeId
  archivedProject: boolean
  isFavorite: boolean
}
export const NestedBuildTypes = memo(function NestedBuildTypes({
  buildTypeId,
  archivedProject,
  isFavorite,
}: NestedBuildTypesProps) {
  const render = useContext(BuildTypesContext)
  return <>{render(buildTypeId, archivedProject, isFavorite)}</>
})
